module.exports = __webpack_public_path__ + "img/gauge.9c4fa887.svg";